import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  breadcrumb?: { label: string; to?: string }[];
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, desc, breadcrumb, children }: PageHeroProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full px-4 pb-10 pt-8 md:px-6 md:pb-12 md:pt-10">
        {breadcrumb && breadcrumb.length > 0 && (
          <nav className="mb-4 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            {breadcrumb.map((item, index) => (
              <span key={`${item.label}-${index}`} className="flex items-center gap-2">
                {item.to ? (
                  <Link to={item.to} className="transition-colors hover:text-primary-600">
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-foreground-700">{item.label}</span>
                )}
                {index < breadcrumb.length - 1 && (
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-s-line text-sm"></i>
                  </span>
                )}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && (
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-semibold text-accent-800">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-bookmark-3-line text-sm"></i>
            </span>
            {eyebrow}
          </span>
        )}
        <h1 className="font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
          {title}
        </h1>
        {desc && <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
        {children && <div className="mt-6">{children}</div>}
      </div>
    </section>
  );
}